import { defineApp } from '../../shell/registry';
import { TENANT_IDS } from '../../shell/session/tenants';

export default defineApp({
    id: 'user-intake',
    path: 'user-intake',
    title: 'User Intake',
    icon: 'mdi-account-multiple-plus',
    description:
        'Load North Wind employees into the graph, then run the Inform sync and cleanup by hand.',
    tenants: [TENANT_IDS.northWind],
    component: () => import('./UserIntakeApp.vue'),
});
